(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shipping-calendar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var ROOT_SELECTOR = '[data-bs-shipping-calendar]';
    var MONTHS_SELECTOR = '[data-bs-shipping-calendar-months]';
    var CLOSURES_SELECTOR = '[data-bs-shipping-calendar-closures]';
    var WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

    var OFFICIAL_HOLIDAYS = {
      2026: {
        '2026-01-01': '元日',
        '2026-01-12': '成人の日',
        '2026-02-11': '建国記念の日',
        '2026-02-23': '天皇誕生日',
        '2026-03-20': '春分の日',
        '2026-04-29': '昭和の日',
        '2026-05-03': '憲法記念日',
        '2026-05-04': 'みどりの日',
        '2026-05-05': 'こどもの日',
        '2026-05-06': '休日',
        '2026-07-20': '海の日',
        '2026-08-11': '山の日',
        '2026-09-21': '敬老の日',
        '2026-09-22': '休日',
        '2026-09-23': '秋分の日',
        '2026-10-12': 'スポーツの日',
        '2026-11-03': '文化の日',
        '2026-11-23': '勤労感謝の日'
      },
      2027: {
        '2027-01-01': '元日',
        '2027-01-11': '成人の日',
        '2027-02-11': '建国記念の日',
        '2027-02-23': '天皇誕生日',
        '2027-03-21': '春分の日',
        '2027-03-22': '休日',
        '2027-04-29': '昭和の日',
        '2027-05-03': '憲法記念日',
        '2027-05-04': 'みどりの日',
        '2027-05-05': 'こどもの日',
        '2027-07-19': '海の日',
        '2027-08-11': '山の日',
        '2027-09-20': '敬老の日',
        '2027-09-23': '秋分の日',
        '2027-10-11': 'スポーツの日',
        '2027-11-03': '文化の日',
        '2027-11-23': '勤労感謝の日'
      }
    };

    function pad2(value) {
      return String(value).padStart(2, '0');
    }

    function dateKey(year, monthIndex, day) {
      return year + '-' + pad2(monthIndex + 1) + '-' + pad2(day);
    }

    function utcDate(year, monthIndex, day) {
      return new Date(Date.UTC(year, monthIndex, day));
    }

    function addUtcDays(date, amount) {
      var result = new Date(date.getTime());
      result.setUTCDate(result.getUTCDate() + amount);
      return result;
    }

    function keyFromUtcDate(date) {
      return dateKey(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    }

    function nthMonday(year, monthIndex, nth) {
      var first = utcDate(year, monthIndex, 1);
      var offset = (8 - first.getUTCDay()) % 7;
      return 1 + offset + (nth - 1) * 7;
    }

    function vernalEquinoxDay(year) {
      return Math.floor(20.8431 + 0.242194 * (year - 1980) - Math.floor((year - 1980) / 4));
    }

    function autumnalEquinoxDay(year) {
      return Math.floor(23.2488 + 0.242194 * (year - 1980) - Math.floor((year - 1980) / 4));
    }

    function calculatedJapaneseHolidays(year) {
      var holidays = {};
      var nationalHolidayKeys = [];

      function addNational(monthIndex, day, name) {
        var key = dateKey(year, monthIndex, day);
        holidays[key] = name;
        nationalHolidayKeys.push(key);
      }

      addNational(0, 1, '元日');
      addNational(0, nthMonday(year, 0, 2), '成人の日');
      addNational(1, 11, '建国記念の日');
      addNational(1, 23, '天皇誕生日');
      addNational(2, vernalEquinoxDay(year), '春分の日');
      addNational(3, 29, '昭和の日');
      addNational(4, 3, '憲法記念日');
      addNational(4, 4, 'みどりの日');
      addNational(4, 5, 'こどもの日');
      addNational(6, nthMonday(year, 6, 3), '海の日');
      addNational(7, 11, '山の日');
      addNational(8, nthMonday(year, 8, 3), '敬老の日');
      addNational(8, autumnalEquinoxDay(year), '秋分の日');
      addNational(9, nthMonday(year, 9, 2), 'スポーツの日');
      addNational(10, 3, '文化の日');
      addNational(10, 23, '勤労感謝の日');

      var cursor = utcDate(year, 0, 2);
      var last = utcDate(year, 11, 30);

      while (cursor <= last) {
        var currentKey = keyFromUtcDate(cursor);
        var previousKey = keyFromUtcDate(addUtcDays(cursor, -1));
        var nextKey = keyFromUtcDate(addUtcDays(cursor, 1));

        if (!holidays[currentKey] && holidays[previousKey] && holidays[nextKey]) {
          holidays[currentKey] = '休日';
        }

        cursor = addUtcDays(cursor, 1);
      }

      nationalHolidayKeys.forEach(function (key) {
        var parts = key.split('-').map(Number);
        var holidayDate = utcDate(parts[0], parts[1] - 1, parts[2]);

        if (holidayDate.getUTCDay() !== 0) {
          return;
        }

        var substitute = addUtcDays(holidayDate, 1);
        while (holidays[keyFromUtcDate(substitute)]) {
          substitute = addUtcDays(substitute, 1);
        }

        holidays[keyFromUtcDate(substitute)] = '休日';
      });

      return holidays;
    }

    function japaneseHolidays(year) {
      return OFFICIAL_HOLIDAYS[year] || calculatedJapaneseHolidays(year);
    }

    function tokyoToday() {
      try {
        var formatter = new Intl.DateTimeFormat('en-CA', {
          timeZone: 'Asia/Tokyo',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
        var values = {};

        formatter.formatToParts(new Date()).forEach(function (part) {
          if (part.type !== 'literal') {
            values[part.type] = part.value;
          }
        });

        return {
          year: Number(values.year),
          monthIndex: Number(values.month) - 1,
          day: Number(values.day),
          key: values.year + '-' + values.month + '-' + values.day
        };
      } catch (error) {
        var now = new Date();
        return {
          year: now.getFullYear(),
          monthIndex: now.getMonth(),
          day: now.getDate(),
          key: dateKey(now.getFullYear(), now.getMonth(), now.getDate())
        };
      }
    }

    function validDateKey(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
      }

      var parts = value.split('-').map(Number);
      var date = utcDate(parts[0], parts[1] - 1, parts[2]);

      return date.getUTCFullYear() === parts[0]
        && date.getUTCMonth() === parts[1] - 1
        && date.getUTCDate() === parts[2];
    }

    function manualClosures(root) {
      var source = root.querySelector(CLOSURES_SELECTOR);
      var closures = {};

      if (!source) {
        return closures;
      }

      try {
        JSON.parse(source.textContent).forEach(function (item) {
          var startKey = String(item.startDate || '').trim();
          var endKey = String(item.endDate || '').trim();
          var label = String(item.label || '').trim() || '発送休止日';

          if (!validDateKey(startKey)) {
            return;
          }

          if (!validDateKey(endKey)) {
            endKey = startKey;
          }

          var startParts = startKey.split('-').map(Number);
          var endParts = endKey.split('-').map(Number);
          var cursor = utcDate(startParts[0], startParts[1] - 1, startParts[2]);
          var end = utcDate(endParts[0], endParts[1] - 1, endParts[2]);

          if (end < cursor) {
            end = new Date(cursor.getTime());
          }

          var safetyCount = 0;
          while (cursor <= end && safetyCount < 370) {
            closures[keyFromUtcDate(cursor)] = label;
            cursor = addUtcDays(cursor, 1);
            safetyCount += 1;
          }
        });
      } catch (error) {
        console.error('発送日カレンダーの休止日データを読み込めませんでした。', error);
      }

      return closures;
    }

    function escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function monthAfter(year, monthIndex, offset) {
      var date = utcDate(year, monthIndex + offset, 1);
      return {
        year: date.getUTCFullYear(),
        monthIndex: date.getUTCMonth()
      };
    }

    function renderMonth(year, monthIndex, today, closures) {
      var firstWeekday = utcDate(year, monthIndex, 1).getUTCDay();
      var daysInMonth = utcDate(year, monthIndex + 1, 0).getUTCDate();
      var totalCells = Math.ceil((firstWeekday + daysInMonth) / 7) * 7;
      var holidays = japaneseHolidays(year);
      var cells = [];

      for (var index = 0; index < totalCells; index += 1) {
        var day = index - firstWeekday + 1;

        if (day < 1 || day > daysInMonth) {
          cells.push('<td aria-hidden="true"></td>');
          continue;
        }

        var date = utcDate(year, monthIndex, day);
        var key = dateKey(year, monthIndex, day);
        var weekday = date.getUTCDay();
        var isSunday = weekday === 0;
        var isSaturday = weekday === 6;
        var holidayName = holidays[key] || '';
        var closureName = closures[key] || '';
        var isClosed = isSunday || isSaturday || Boolean(holidayName) || Boolean(closureName);
        var isToday = key === today.key;
        var classes = [];
        var reasons = [];

        if (isClosed) {
          classes.push('bs-shipping-calendar__cell--closed');
        }
        if (isSunday) {
          classes.push('bs-shipping-calendar__cell--sunday');
        }
        if (isSaturday) {
          classes.push('bs-shipping-calendar__cell--saturday');
        }
        if (holidayName) {
          classes.push('bs-shipping-calendar__cell--holiday');
        }
        if (closureName) {
          classes.push('bs-shipping-calendar__cell--manual');
        }
        if (isToday) {
          classes.push('bs-shipping-calendar__cell--today');
        }

        if (closureName) {
          reasons.push(closureName);
        } else if (holidayName) {
          reasons.push(holidayName);
        } else if (isClosed) {
          reasons.push('発送休止日');
        }

        var ariaLabel = year + '年' + (monthIndex + 1) + '月' + day + '日';
        if (isToday) {
          ariaLabel += '、本日';
        }
        if (reasons.length) {
          ariaLabel += '、' + reasons.join('、');
        }

        cells.push(
          '<td class="' + classes.join(' ') + '">'
          + '<span class="bs-shipping-calendar__day" aria-label="' + escapeHtml(ariaLabel) + '" title="' + escapeHtml(ariaLabel) + '">'
          + day
          + '</span>'
          + '</td>'
        );
      }

      var rows = '';
      for (var rowIndex = 0; rowIndex < cells.length / 7; rowIndex += 1) {
        rows += '<tr>' + cells.slice(rowIndex * 7, rowIndex * 7 + 7).join('') + '</tr>';
      }

      return '<article class="bs-shipping-calendar__month">'
        + '<h3 class="bs-shipping-calendar__month-title">' + year + '年' + (monthIndex + 1) + '月</h3>'
        + '<table class="bs-shipping-calendar__table">'
        + '<thead><tr>'
        + WEEKDAYS.map(function (weekday) {
          return '<th scope="col">' + weekday + '</th>';
        }).join('')
        + '</tr></thead>'
        + '<tbody>' + rows + '</tbody>'
        + '</table>'
        + '</article>';
    }

    function initialize(root) {
      if (!root || root.getAttribute('data-bs-shipping-calendar-ready') === 'true') {
        return;
      }

      var monthsContainer = root.querySelector(MONTHS_SELECTOR);
      if (!monthsContainer) {
        return;
      }

      var today = tokyoToday();
      var closures = manualClosures(root);
      var firstMonth = monthAfter(today.year, today.monthIndex, 0);
      var secondMonth = monthAfter(today.year, today.monthIndex, 1);

      monthsContainer.innerHTML = renderMonth(firstMonth.year, firstMonth.monthIndex, today, closures)
        + renderMonth(secondMonth.year, secondMonth.monthIndex, today, closures);

      root.setAttribute('data-bs-shipping-calendar-ready', 'true');
    }

    function initializeAll(scope) {
      if (scope.matches && scope.matches(ROOT_SELECTOR)) {
        initialize(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initializeAll(document);
      });
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
